<template>
  <div class="card-item p-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="title">Kat</h3>
      <a @click="createDeck" href="javascript:void(0)" class="theme-btn theme-btn-small"><i class="la la-plus mr-1"></i>Yeni Kat Yarat</a>
    </div>
    <div class="table-form table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th scope="col">Adı</th>
          <th>Sırası</th>
          <th>Resim</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="deck in deckList" v-bind:key="deck.id">
          <td scope="row">{{deck.name}}</td>
          <td>{{ deck.order }}</td>
          <td>
            <big-image-component v-if="deck.imageUrl != null" :url="deck.imageUrl"></big-image-component>
          </td>
          <td class="row mt-auto">
            <div :class="deck.id === null ? 'customDisabled':''" class="table-content mr-2" v-on:click="deleteDeck(deck)">
              <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete">
                <i class="la la-trash"></i>
              </a>
            </div>
            <div class="table-content" @click="showDeckDetail(deck)">
              <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                <i class="la la-edit"></i>
              </a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="section-block mb-4"></div>
  </div>
</template>

<script>
import BigImageComponent from "../../common/BigImageComponent";
import messagePopupManager from "../../../util/messagePopupManager";


export default {
  name: "DeckList",
  components: {BigImageComponent},
  computed:{
    deckList:{
      get(){
        let deckList = this.$store.getters.getDeckList
        if(deckList == null){
          return null;
        }
        return deckList.sort((a, b) => {
          return (a.order > b.order) ? 1 : -1
        });
      }
    },
  },
  methods:{
    showDeckDetail(deck){
      let editDeck = JSON.parse(JSON.stringify(deck));
      this.$store.commit("setDeck",editDeck)

      $("#cruiseDeckPopup").modal('show')
    },
    createDeck(){
      this.$store.commit("setDeck", {id:null})

      $("#cruiseDeckPopup").modal('show')
    },
    deleteDeck(deck){
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deleteDeck", deck);
      })
    }
  },
  mounted() {
    // this.$store.dispatch("loadDeckList", this.$store.getters.getCruise.id);
  }
}
</script>

<style scoped>
.customDisabled{
  pointer-events: none;
  opacity: 0.4;
}
</style>